import React, { useState } from 'react';

const Footer = () => {
    const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
    const [termsModalOpen, setTermsModalOpen] = useState(false);

    // 개인정보처리방침 모달 열기/닫기
    const handlePrivacyModalOpen = () => setPrivacyModalOpen(true);
    const handlePrivacyModalClose = () => setPrivacyModalOpen(false);

    // 이용약관 모달 열기/닫기
    const handleTermsModalOpen = () => setTermsModalOpen(true);
    const handleTermsModalClose = () => setTermsModalOpen(false);

    return (
        <>
            <footer style={{
                backgroundColor: '#2a3652',
                borderTop: '1px solid #dee2e6',
                padding: '30px 0',
                marginTop: '0px'
            }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12 mb-3">
                            <h5 style={{ color: '#dee2e6', fontWeight: 'bold', marginBottom: '15px' }}>Sort Tournament Maker</h5>
                            <p style={{ color: '#dee2e6', fontSize: '14px', marginBottom: '10px' }}>
                                간편하고 실용적인 토너먼트 대진표 관리 시스템
                            </p>
                            <p style={{ color: '#dee2e6', fontSize: '14px', marginBottom: 0 }}>
                                <i className="bi bi-envelope me-2"></i>
                                문의: hatssarjy@gmail.com
                            </p>
                        </div>
                    </div>
                    <hr style={{ margin: '20px 0', borderColor: '#dee2e6' }} />
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '10px'
                    }}>
                        <div style={{ color: '#dee2e6', fontSize: '13px' }}>
                            © 2025 Sort Tournament Maker. All rights reserved.
                        </div>
                        <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                            <button
                                onClick={handlePrivacyModalOpen}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#dee2e6',
                                    cursor: 'pointer',
                                    padding: 0,
                                    fontSize: '13px'
                                }}
                            >
                                개인정보처리방침
                            </button>
                            <button
                                onClick={handleTermsModalOpen}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#dee2e6',
                                    cursor: 'pointer',
                                    padding: 0,
                                    fontSize: '13px'
                                }}
                            >
                                이용약관
                            </button>
                        </div>
                    </div>
                </div>
            </footer>

            {/* 개인정보처리방침 모달 */}
            {privacyModalOpen && (
                <div
                    className="policy-modal-overlay"
                    onClick={handlePrivacyModalClose}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                        padding: '20px'
                    }}
                >
                    <div
                        className="policy-modal-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '30px',
                            maxWidth: '800px',
                            width: '100%',
                            maxHeight: '80vh',
                            overflowY: 'auto',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                            position: 'relative'
                        }}
                    >
                        {/* 닫기 버튼 */}
                        <button
                            onClick={handlePrivacyModalClose}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                background: 'none',
                                border: 'none',
                                fontSize: '24px',
                                cursor: 'pointer',
                                color: '#dee2e6',
                                padding: 0,
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            ×
                        </button>

                        <h4 style={{ marginBottom: '20px', fontWeight: 'bold' }}>개인정보처리방침</h4>

                        <div style={{ lineHeight: '1.8', fontSize: '14px', color: '#333' }}>
                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제1조 (개인정보의 처리 목적)</h6>
                                <p>Tournament Maker(이하 "본 서비스")는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>회원 가입 및 관리</li>
                                    <li>대회 신청 및 참가자 관리</li>
                                    <li>토너먼트 대진표 생성 및 관리</li>
                                    <li>서비스 제공 및 운영</li>
                                    <li>고객 문의 및 민원 처리</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제2조 (개인정보의 처리 및 보유기간)</h6>
                                <p>본 서비스는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>회원정보: 회원 탈퇴 시까지 (단, 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지)</li>
                                    <li>대회 참가 정보: 대회 종료 후 3년</li>
                                    <li>고객 문의 정보: 문의 처리 완료 후 1년</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제3조 (처리하는 개인정보의 항목)</h6>
                                <p>본 서비스는 다음의 개인정보 항목을 처리하고 있습니다.</p>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>필수항목: 이름, 이메일, 비밀번호, 연락처</li>
                                    <li>선택항목: 생년월일, 소속, 체급 정보</li>
                                    <li>자동 수집 항목: IP 주소, 쿠키, 서비스 이용 기록, 접속 로그</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제4조 (개인정보의 제3자 제공)</h6>
                                <p>본 서비스는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제5조 (개인정보의 파기)</h6>
                                <p>본 서비스는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.</p>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>파기절차: 불필요한 개인정보 및 개인정보파일은 개인정보 책임자의 승인을 받아 파기합니다.</li>
                                    <li>파기방법: 전자적 파일 형태의 정보는 복구 불가능한 방법으로 영구 삭제하고, 종이 문서는 분쇄기로 분쇄하거나 소각합니다.</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제6조 (정보주체의 권리·의무 및 행사방법)</h6>
                                <p>정보주체는 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</p>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>개인정보 열람 요구</li>
                                    <li>개인정보 오류 등이 있을 경우 정정 요구</li>
                                    <li>개인정보 삭제 요구</li>
                                    <li>개인정보 처리정지 요구</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제7조 (개인정보의 안전성 확보조치)</h6>
                                <p>본 서비스는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육</li>
                                    <li>기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치</li>
                                    <li>물리적 조치: 전산실, 자료보관실 등의 접근통제</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제8조 (개인정보 보호책임자)</h6>
                                <p>본 서비스는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
                                <ul style={{ paddingLeft: '20px', listStyle: 'none' }}>
                                    <li>이메일: hatssarjy@gmail.com</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제9조 (개인정보처리방침의 변경)</h6>
                                <p>본 개인정보처리방침은 2025년 1월 1일부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.</p>
                            </section>
                        </div>

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button
                                className="btn btn-primary"
                                onClick={handlePrivacyModalClose}
                                style={{ padding: '10px 30px' }}
                            >
                                확인
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 이용약관 모달 */}
            {termsModalOpen && (
                <div
                    className="policy-modal-overlay"
                    onClick={handleTermsModalClose}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                        padding: '20px'
                    }}
                >
                    <div
                        className="policy-modal-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '30px',
                            maxWidth: '800px',
                            width: '100%',
                            maxHeight: '80vh',
                            overflowY: 'auto',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                            position: 'relative'
                        }}
                    >
                        {/* 닫기 버튼 */}
                        <button
                            onClick={handleTermsModalClose}
                            style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                background: 'none',
                                border: 'none',
                                fontSize: '24px',
                                cursor: 'pointer',
                                color: '#dee2e6',
                                padding: 0,
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            ×
                        </button>

                        <h4 style={{ marginBottom: '20px', fontWeight: 'bold' }}>이용약관</h4>

                        <div style={{ lineHeight: '1.8', fontSize: '14px', color: '#333' }}>
                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제1조 (목적)</h6>
                                <p>본 약관은 Tournament Maker(이하 "본 서비스")가 제공하는 토너먼트 관리 서비스의 이용과 관련하여 본 서비스와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제2조 (용어의 정의)</h6>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>"서비스"라 함은 본 서비스가 제공하는 토너먼트 대진표 생성, 대회 관리 등 모든 서비스를 의미합니다.</li>
                                    <li>"회원"이라 함은 본 서비스에 접속하여 본 약관에 따라 본 서비스가 제공하는 서비스를 받는 자를 말합니다.</li>
                                    <li>"아이디(ID)"라 함은 회원의 식별과 서비스 이용을 위하여 회원이 정하고 본 서비스가 승인하는 문자와 숫자의 조합을 의미합니다.</li>
                                    <li>"비밀번호"라 함은 회원이 부여받은 아이디와 일치되는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 의미합니다.</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제3조 (약관의 효력 및 변경)</h6>
                                <p>① 본 약관은 서비스를 이용하고자 하는 모든 회원에 대하여 그 효력을 발생합니다.</p>
                                <p>② 본 서비스는 합리적인 사유가 발생할 경우 관련 법령에 위배되지 않는 범위 안에서 본 약관을 변경할 수 있으며, 변경된 약관은 서비스 내 공지사항을 통해 공지합니다.</p>
                                <p>③ 회원은 변경된 약관에 동의하지 않을 경우 회원 탈퇴를 요청할 수 있으며, 변경된 약관의 효력 발생일 이후에도 서비스를 계속 이용할 경우 약관의 변경 사항에 동의한 것으로 간주됩니다.</p>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제4조 (회원가입)</h6>
                                <p>① 회원가입은 이용자가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 본 서비스가 이러한 신청에 대하여 승낙함으로써 체결됩니다.</p>
                                <p>② 본 서비스는 다음 각 호에 해당하는 회원가입 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.</p>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>타인의 명의를 사용하여 신청한 경우</li>
                                    <li>허위의 정보를 기재하거나, 본 서비스가 제시하는 내용을 기재하지 않은 경우</li>
                                    <li>만 14세 미만 아동이 법정대리인의 동의를 얻지 아니한 경우</li>
                                    <li>기타 본 서비스가 정한 이용신청 요건이 만족되지 않았을 경우</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제5조 (서비스의 제공 및 변경)</h6>
                                <p>① 본 서비스는 다음과 같은 업무를 수행합니다.</p>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>토너먼트 대진표 생성 및 관리</li>
                                    <li>대회 신청 및 참가자 관리</li>
                                    <li>경기 결과 기록 및 통계</li>
                                    <li>기타 본 서비스가 정하는 업무</li>
                                </ul>
                                <p>② 본 서비스는 운영상, 기술상의 필요에 따라 제공하고 있는 서비스를 변경할 수 있습니다.</p>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제6조 (서비스의 중단)</h6>
                                <p>① 본 서비스는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</p>
                                <p>② 본 서비스는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상하지 않습니다. 다만, 본 서비스의 고의 또는 과실에 의한 경우에는 그러하지 아니합니다.</p>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제7조 (회원의 의무)</h6>
                                <p>① 회원은 다음 행위를 하여서는 안 됩니다.</p>
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>신청 또는 변경 시 허위내용의 등록</li>
                                    <li>타인의 정보 도용</li>
                                    <li>본 서비스에 게시된 정보의 변경</li>
                                    <li>본 서비스가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
                                    <li>본 서비스 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
                                    <li>본 서비스 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                                    <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제8조 (저작권의 귀속 및 이용제한)</h6>
                                <p>① 본 서비스가 작성한 저작물에 대한 저작권 기타 지적재산권은 본 서비스에 귀속합니다.</p>
                                <p>② 회원은 본 서비스를 이용함으로써 얻은 정보 중 본 서비스에게 지적재산권이 귀속된 정보를 본 서비스의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.</p>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제9조 (분쟁해결)</h6>
                                <p>① 본 서비스는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위해 정보를 제공합니다.</p>
                                <p>② 본 서비스는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.</p>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>제10조 (재판권 및 준거법)</h6>
                                <p>① 본 서비스와 이용자 간에 발생한 서비스 이용에 관한 분쟁에 대하여는 대한민국 법을 적용합니다.</p>
                                <p>② 본 서비스와 이용자 간에 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다.</p>
                            </section>

                            <section style={{ marginBottom: '25px' }}>
                                <p style={{ fontWeight: 'bold' }}>부칙</p>
                                <p>본 약관은 2025년 1월 1일부터 시행됩니다.</p>
                            </section>
                        </div>

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button
                                className="btn btn-primary"
                                onClick={handleTermsModalClose}
                                style={{ padding: '10px 30px' }}
                            >
                                확인
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Footer;
